<template>
    <div  class="d-block w-100 text-center">
        <font-awesome-icon
                @click="click"
                :icon="['fas', 'times-circle']"
                class="red cursor-pointer"
                size="lg"
        >
        </font-awesome-icon>
        <b-modal
            size="md"
            title="Confirmation"
            :visible="visible"
            scrollable
        >
            <vue-element-loading :active="loading" :is-full-screen="false"/>

            {{ modalText }}
            <template slot="modal-footer">
                <b-button
                        variant="outline-secondary"
                        @click="visible = false">
                    Cancel
                    <font-awesome-icon
                            :icon="['far', 'times']">
                    </font-awesome-icon>
                </b-button>
                <b-button
                        class="btn-arrow"
                        variant="danger"
                        @click="onRemove"
                >
                    Confirm
                    <font-awesome-icon
                            :icon="['far', 'arrow-right']">
                    </font-awesome-icon>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      visible: false,
      loading: false,
    };
  },
  computed: {
    modalText() {
      if (this.params.modalText) {
        return this.params.modalText;
      }

      return 'Are you sure you want to perform this action?';
    },
  },
  methods: {
    click() {
      if (this.params.showConfirmModal) {
        this.visible = true;
        return;
      }

      this.onRemove();
    },
    async onRemove() {
      this.loading = true;

      await this.params.onRemoveClick();
      this.loading = false;
      this.visible = false;
    },
  },
});
</script>
